// Reducers/setPasswordReducer.js
import {
    SET_PASSWORD_REQUEST,
    SET_PASSWORD_SUCCESS,
    SET_PASSWORD_FAILURE,
  } from "../Actions/UpdatePasswordAction";
  
  const initialState = {
    loading: false,
    successMessage: "",
    errorMessage: "",
  };
  
  const UpdatePasswordReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_PASSWORD_REQUEST:
        return { ...state, loading: true, successMessage: "", errorMessage: "" };
      case SET_PASSWORD_SUCCESS:
        return {
          ...state,
          loading: false,
          successMessage: "Password updated successfully.",
          errorMessage: "",
        };
      case SET_PASSWORD_FAILURE:
        return {
          ...state,
          loading: false,
          successMessage: "",
          errorMessage: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default UpdatePasswordReducer;
  